module.exports = __webpack_public_path__ + "img/lantern.9d81c9cc.png";